/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIAllInOneUser } from './APIAllInOneUser';
import {
    APIAllInOneUserFromJSON,
    APIAllInOneUserFromJSONTyped,
    APIAllInOneUserToJSON,
} from './APIAllInOneUser';

/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIMessage
 */
export interface APIMessage {
    /**
     * 
     * @type {string}
     * @memberof APIMessage
     */
    readonly self: string;
    /**
     * 
     * @type {string}
     * @memberof APIMessage
     */
    readonly messageType: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof APIMessage
     */
    eventData?: { [key: string]: any; } | null;
    /**
     * 
     * @type {Date}
     * @memberof APIMessage
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {string}
     * @memberof APIMessage
     */
    body: string;
    /**
     * 
     * @type {APIAllInOneUser}
     * @memberof APIMessage
     */
    readonly author: APIAllInOneUser | null;
    /**
     * 
     * @type {string}
     * @memberof APIMessage
     */
    readonly channel: string;
    /**
     * 
     * @type {boolean}
     * @memberof APIMessage
     */
    readonly isNewMessage: boolean;
}

/**
 * Check if a given object implements the APIMessage interface.
 */
export function instanceOfAPIMessage(value: object): value is APIMessage {
    if (!('self' in value) || value['self'] === undefined) return false;
    if (!('messageType' in value) || value['messageType'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('body' in value) || value['body'] === undefined) return false;
    if (!('author' in value) || value['author'] === undefined) return false;
    if (!('channel' in value) || value['channel'] === undefined) return false;
    if (!('isNewMessage' in value) || value['isNewMessage'] === undefined) return false;
    return true;
}

export function APIMessageFromJSON(json: any): APIMessage {
    return APIMessageFromJSONTyped(json, false);
}

export function APIMessageFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIMessage {
    if (json == null) {
        return json;
    }
    return {
        
        'self': json['self'],
        'messageType': json['message_type'],
        'eventData': json['event_data'] == null ? undefined : json['event_data'],
        'createdAt': (new Date(json['created_at'])),
        'body': json['body'],
        'author': APIAllInOneUserFromJSON(json['author']),
        'channel': json['channel'],
        'isNewMessage': json['is_new_message'],
    };
}

export function APIMessageToJSON(value?: Omit<APIMessage, 'self'|'message_type'|'created_at'|'author'|'channel'|'is_new_message'> | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'event_data': value['eventData'],
        'body': value['body'],
    };
}

